import React from 'react';
import { Alert } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const KnowledgeInfoBanner = ({ message }) => (
  <Alert
    severity='info'
    icon={<InfoOutlinedIcon fontSize='inherit' />}
    sx={{
      mb: 2.5,
      borderRadius: 2,
      bgcolor: 'rgba(25, 118, 210, 0.08)',
      color: 'text.primary',
      '& .MuiAlert-icon': { color: 'primary.main' },
    }}
  >
    {message}
  </Alert>
);

export default KnowledgeInfoBanner;
